import { cn } from "@super-resume-new/ui/lib/utils";
import type { LucideIcon } from "lucide-react";
import type { ReactNode } from "react";

import { Display, Eyebrow } from "./landing/primitives";

interface PageHeroProps {
  eyebrow: string;
  icon?: LucideIcon;
  title: ReactNode;
  description?: ReactNode;
  children?: ReactNode;
  /** Emerald marks the ATS booster; every other screen keeps the violet default. */
  accent?: "violet" | "emerald";
  className?: string;
}

/** Centred hero used by the tool and content routes (tailor, ats-booster, jobs, faq). */
export function PageHero({
  eyebrow,
  icon,
  title,
  description,
  children,
  accent = "violet",
  className,
}: PageHeroProps) {
  return (
    <section className={cn("mb-8 text-center", className)}>
      <Eyebrow
        icon={icon}
        className={accent === "emerald" ? "[&_svg]:text-emerald-500" : undefined}
      >
        {eyebrow}
      </Eyebrow>
      <Display as="h1" className="mt-4">
        {title}
      </Display>
      {description ? (
        <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-muted-foreground">
          {description}
        </p>
      ) : null}
      {children}
    </section>
  );
}
